interface IconProps {
  className?: string;
}

/** Close glyph of the info modals on the DubaiExpress product page. */
const CloseIcon = ({ className }: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    aria-hidden
    className={className}
  >
    <path d="M6 6l12 12M18 6 6 18" />
  </svg>
);

export default CloseIcon;
